import { render, staticRenderFns } from "./PgaOfferEvaluationExpectedRevenueCreate.vue?vue&type=template&id=0330784b&scoped=true&"
import script from "./PgaOfferEvaluationExpectedRevenueCreate.vue?vue&type=script&lang=ts&"
export * from "./PgaOfferEvaluationExpectedRevenueCreate.vue?vue&type=script&lang=ts&"
import style0 from "./PgaOfferEvaluationExpectedRevenueCreate.vue?vue&type=style&index=0&id=0330784b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0330784b",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VFadeTransition,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0330784b')) {
      api.createRecord('0330784b', component.options)
    } else {
      api.reload('0330784b', component.options)
    }
    module.hot.accept("./PgaOfferEvaluationExpectedRevenueCreate.vue?vue&type=template&id=0330784b&scoped=true&", function () {
      api.rerender('0330784b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/OfferEvaluation/components/create/sub-components/PgaOfferEvaluationExpectedRevenueCreate.vue"
export default component.exports